"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttributedImageContainer = void 0;
exports.default = AttributedImage;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _attributionBlock = _interopRequireDefault(require("@site/pattern-library-core/attribution-block"));
var _image = require("@site/pattern-library-core/image");
const AttributedImageContainer = exports.AttributedImageContainer = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "AttributedImageContainer",
  class: "pl-ao7ir2t"
});

/**
 * Render image with attribution.
 * @module AttributedImage
 *
 * @param {Object} props React props
 * @param {String} props.attribution attribution text
 * @param {String} props.altText image alt text
 * @param {Number} props.height image height
 * @param {Number} props.width image width
 * @param {String} props.attributionPosition Attribution text position
 * @param {Boolean} props.hideAttributionMobile hide attribution on mobile
 * @param {String} props.inset Padding inset
 * @param {Boolean} props.initialInView initialInView
 * @param {Object} props.imageContextProps imageContextProps
 * @returns {React.ReactElement} HTML Image element with Attribution Block
 * @public
 */
function AttributedImage({
  attribution,
  browserImage = {},
  attributionPosition = 'bottom-right',
  hideAttributionMobile = false,
  inset = 'unset',
  initialInView
}) {
  const {
    url,
    altText,
    width = 1,
    height = 1
  } = browserImage;
  return /*#__PURE__*/_react.default.createElement(AttributedImageContainer, {
    inset: inset,
    "data-cy": "attributed-image"
  }, url && /*#__PURE__*/_react.default.createElement(_image.LazyImage, {
    url: url,
    altText: altText,
    width: width,
    height: height,
    initialInView: initialInView
  }), attribution && /*#__PURE__*/_react.default.createElement(_attributionBlock.default, {
    attribution: attribution,
    attributionPosition: attributionPosition,
    mobileHide: hideAttributionMobile
  }));
}
AttributedImage.propTypes = {
  attribution: _propTypes.default.string,
  browserImage: _propTypes.default.shape(_image.imgPropShape),
  attributionPosition: _propTypes.default.oneOf(['bottom-left', 'bottom-right']),
  inset: _propTypes.default.oneOf(['inset-left', 'inset-right', 'unset']),
  hideAttributionMobile: _propTypes.default.bool,
  imageContextProps: _propTypes.default.object,
  initialInView: _propTypes.default.bool
};